export default {
    home: '/',
    login: '/login',
    bannernew: '/bannernew',
    banneredit: '/banneredit/:id',
    registration: '/registration',
    successRegistration: '/registration/success',
    notificationsCreate: '/notifications/create',
    notifications: '/notifications/',
}